import type { CSSProperties } from 'react'

/** Wordmark do produto: orbe de luz + "Lumo". Herda o tamanho do contexto (font-size). */
export function Wordmark({ style }: { style?: CSSProperties }) {
  return (
    <span className="brand" style={style}>
      <span className="brand-mark" aria-hidden />
      Lumo
    </span>
  )
}
